import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function TimesheetPreview({ id }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      navigate(`/Administrative/HR/Timesheet/Create/${id}`, { replace: true });
    }
  }, [id, navigate]);

  return null;
}
